import Repository from '@/repositories/Repository'

export default {

    listGrades(page, itemsPerPage, search) {
        var response = Repository.get('/grade/listgrades', {
                params:{
                    page: page,
                    itemsperpage: itemsPerPage,
                    search: search            
                } 
            });
        return response;
    },

};
